import * as React from 'react'
import { stateful, IOWidget, mkWidget, Action } from "widgets-for-react";

export type TabProps = { 
  tab: IOWidget<boolean, any>
  content: IOWidget<boolean, any>
}

type TabState = { activeIndex: number }

export const tabs = (items: TabProps[]) => (
  stateful<TabState>()(
    s0 => mkWidget<Action<TabState>>({
      run: setState => (
        <div>
          <div className="tabs">
            {items.map(
              (item, index) => item
                .tab(s0.activeIndex === index)
                .map<Action<TabState>>(() => s1 => ({ ...s1, activeIndex: index }))
                .run(setState)
            )}
          </div>
          <div className="contents">
            {items.map(
              (item, index) => item
                .content(s0.activeIndex === index)
                .map<Action<TabState>>(() => s1 => ({ ...s1, activeIndex: index }))
                .run(setState)
            )}
          </div>
        </div>
      )
    }).map(a => a(s0))
  )({ activeIndex: 0 }).run(() => null)
)
